import moment from 'moment';
export function customFormatter(fecha, formato) {
  return fecha == null ? '' : moment(fecha).format(formato);
}
